import Swal from "sweetalert2";
import React, { useState, useEffect, useContext } from "react";
import { useSelector } from "react-redux";
import { RiSearch2Line } from "react-icons/ri";
import {
  Center,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";

import "./styles.css";
import { Title } from "styled/Title";
import { useForm } from "hooks/useForm";
import { IconGeneric } from "styled/Icons.styled";
import { ButtonStyled } from "styled/Buttons.styled";
import { HeaderSearch } from "styled/SectionContainer.styled";
import { LabelGroup } from "pages/RefProductInter/LabelGroup";
import SpinnerComponent from "components/Spinner/SpinnerComponent";
import CardInfoSearchPlateVehicle from "components/Security/CardInfoSearchPlateVehicle";
import {
  __getsearchVehiclePlateEntry,
  __postcreateSecurityEntryAndExit,
  _getSearchCodeFormEntry,
} from "request/__Security";
import { ModalGeneric } from "components/modal/ModalGeneric";
import { useModal } from "hooks/useModal";
import FormRegisterPublic from "../FormRegisterPublic";
import {
  authorized,
  propsSwalSecurity,
  styleSelected,
  styleUnSelected,
} from "utils/generalData";
import useTypeTransport from "hooks/useTypeTransport";
import useVehicularDoors from "hooks/useVehicularDoors";
import {
  dataPassesAuthorized,
  dataPassesPresented,
  filterDataEntry,
} from "./functions";
import ImageNotFound from "../../../assets/bro.png";
import { FuncionLetraNumberOnly } from "components/Funciones/FuncionLetraNumberOnly";
import { AlertErrorAlert } from "components/Alerts/AlertErrorAlert";

import { AuthContext } from "context/AuthContext";
import InputSelect from "components/InputSelect/InputSelect";
import useStatusListener from "hooks/useStatusListener";
import { isNumber, isObject } from "utils/type-check-utils";

/**
 *  EntriesVehicle - Componente para realizar busquedas por placa de vehiculos y por busqueda especifica
 *
 * @component
 * @return {Component} Retorna componente JSX, muestra la data mediante cards
 */

const EntriesVehicle = () => {
  const token = useSelector((state) => state.auth.dataUser.token);

  const { typeTransport } = useTypeTransport();
  const { dataVehicheDoor } = useVehicularDoors("entry");
  const [loading, setLoading] = useState(false);
  const [presentedData, setpresentedData] = useState([]);
  const [authorizedData, setAuthorizedData] = useState([]);
  const [dataFreePasses, setDataFreePasses] = useState([]);
  const [dataPasses, setpassesDataAuthorized] = useState([]);
  const [specificSearch, setSpecificSearch] = useState(null);
  const [selectAuthorized, setSelectAuthorized] = useState(true);
  const [isOpenSearch, onOpenSearch, onCloseSearch] = useModal();
  const [dataSearchVehiclePlate, setdataSearchVehiclePlate] = useState([]);
  const [uploaded, setUploaded] = useState({});
  const [CreateDispacth, setCreateDispacth] = useState(0);
  const [IsActive, setIsActive] = useState(true);

  const [headerInfo, setHeaderInfo] = useState({
    pendingPass: null,
    pendingPassComex: null,
  });
  const [vehicleDoor, setVehicleDoor] = useState(null);
  const [selectTypeTransport, setSelectTypeTransport] = useState(null);
  const [selectUserQualified, setSelectUserQualified] = useState(null);
  const [openAlert] = AlertErrorAlert();
  const { authUser } = useContext(AuthContext);
  const { admin, is_commerce } = authUser;

  const [values, handleInputChange, reset, setValues] = useForm({
    plateVehicle: "",
    specificSearch: "",
    // form serv public
    name: "",
    identification: "",
    container_1: "",
    capacity_container_1: "",
    container_2: "",
    capacity_container_2: "",
    description: "",
    plateVehicleNewRegister: "",
  });

  const handleSubmitRegisterAll = () => {

    const hasEmptyDescription = dataPasses.some((pass) =>
      !pass.description_security || pass.description_security.toString().trim() === ""
    );

    if (hasEmptyDescription) {
      openAlert("El campo 'Descripción' es obligatorio para todos los registros.", "error");
      return;
    }

    Swal.fire(propsSwalSecurity).then((result) => {
      if (result.isConfirmed) {
        handleRegisterAllEntryAutorized();
      }
    });
  };

  const [createStatusdispatch, setCreatedispatch] = useState(0);

  // const arrayAlert = [
  //   "msg_alert",
  //   "msg_validate",
  //   "msg_alert_r",
  //   "msg_validate_kg",
  // ];

  const [idPassAssociated, setIdPassAssociated] = useState([]);

  const getsearchVehiclePlateEntry = async () => {
    if (values.plateVehicle) {
      setLoading(true);
      try {
        const plate = values.plateVehicle.toUpperCase();
        const res = await __getsearchVehiclePlateEntry(token, plate);
        console.log(res, "getsearchVehiclePlateEntry");
        const status = res?.data?.status;
        setCreatedispatch(res?.data?.createdispatch);
        const Message = res?.data?.status?.message;
        const Code = status?.code || status;

        if (Code !== 200) {
          openAlert(Message, "error");
          setdataSearchVehiclePlate(null);
          setSpecificSearch(null);
          setHeaderInfo({
            pendingPass: null,
            pendingPassComex: null,
          });
          // reset();
        } else {
          const data = res?.data?.data;

          const idPass =
            isObject(data) &&
            data.reduce((acc, passCurrent) => {
              if (isNumber(passCurrent.entryPasses_id)) {
                acc.push({
                  id: passCurrent.entryPasses_id,
                  status: passCurrent.status,
                });
              }

              return acc;
            }, []);

          setIdPassAssociated(idPass);
          // const firtElement = data[0];

          // Object.entries(firtElement).map(([key, valor]) => {
          //   if (arrayAlert.includes(key)) {
          //     openAlert(valor, "", "", key);
          //   }
          // });
          setHeaderInfo({
            pendingPass: res?.data?.pending_passes ?? null,
            pendingPassComex: res?.data?.pending_passes_comex || null,
          });

          if (!data.length) {
            openAlert("No hay documentos con la placa digitada", "error");
          }

          setSpecificSearch(null);
          const passesAuthorized = dataPassesAuthorized(data);
          const passesPresented = dataPassesPresented(data);
          // const cargado = passesPresented.find((data) => data.empty_pass === 0);
          // setUploaded(cargado);

          if (!passesAuthorized.length) {
            setSelectAuthorized(false);
          }
          const passeFree = passesPresented.filter(
            (passes) => passes.free_pass === 1
          );
          const dataPasseFree = filterDataEntry(passeFree, data);
          const dataAuthorized = filterDataEntry(passesAuthorized, data);

          setDataFreePasses(dataPasseFree);
          setpassesDataAuthorized(dataAuthorized);
          setpresentedData(passesPresented);
          setAuthorizedData(passesAuthorized);
          setSelectTypeTransport({
            value: data[0]?.typeTransport_id,
            label: data[0]?.type_transport,
            is_container: data[0]?.is_container,
          });
          setdataSearchVehiclePlate(data);
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    } else {
      openAlert("Debe ingresar una placa.", "error");
      setHeaderInfo({
        pendingPass: null,
        pendingPassComex: null,
      });
    }
  };

  useEffect(() => {
    if (admin || is_commerce) {
      setIsActive(false);
    }
  }, [authUser]);

  const getSearchCodeFormEntry = async () => {
    if (!values.specificSearch) {
      openAlert("Debe ingresar un número de pase", "error");
    } else {
      setLoading(true);
      try {
        const res = await _getSearchCodeFormEntry(
          token,
          values?.specificSearch
        );
        console.log(res, "getSearchCodeFormEntry");
        const status = res?.data?.status;
        const Message = res?.data?.status?.message;
        const Code = status?.code || status;

        if (Code !== 200) {
          openAlert(Message, "error");
          setdataSearchVehiclePlate(null);
          setSpecificSearch(null);
          setHeaderInfo({
            pendingPass: null,
            pendingPassComex: null,
          });
          // reset();
        } else {
          setHeaderInfo({
            pendingPass: res?.data?.pending_passes || null,
            pendingPassComex: res?.data?.pending_passes_comex || null,
          });

          if (status?.data?.msg_validate) {
            openAlert(status?.data?.msg_validate, "error");
          }
          if (status?.data?.msg_alert_r) {
            openAlert(status?.data?.msg_alert_r, "");
          }
          if (status?.data?.msg_validate_kg) {
            openAlert(status?.data?.msg_validate_kg, "");
          }
          setSelectTypeTransport({
            value: status?.data?.typeTransport_id,
            label: status?.data?.type_transport,
            is_container: status?.data?.is_container,
          });

          console.log(status?.data);
          setSpecificSearch(status?.data);
          const dataPassesAuthorized = [
            {
              driver: status?.data?.driver,
              id: status?.data?.entryPasses_id,
              vehicle_plate: status?.data?.vehicle_plate,
              identification: status?.data?.identification,
              description_security: status?.data?.observations,
              typeTransport_id: status?.data?.typeTransport_id,
              qualifiedUser_id: status?.data?.qualifiedUser_id,
              container_1:
                status?.data?.container_1 === null
                  ? ""
                  : status?.data?.container_1,
              container_2:
                status?.data?.container_2 === null
                  ? ""
                  : status?.data?.container_2,
              capacity_container_1:
                status?.data?.capacity_container_1 === null
                  ? ""
                  : status?.data?.capacity_container_1,
              capacity_container_2:
                status?.data?.capacity_container_2 === null
                  ? ""
                  : status?.data?.capacity_container_2,
            },
          ];
          setpassesDataAuthorized(dataPassesAuthorized);
          if (status?.data?.status === authorized) {
          }
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleRegisterAllEntryAutorized = async () => {
    setLoading(true);
    try {
      const res = await __postcreateSecurityEntryAndExit(
        token,
        {
          vehicularDoor_id: vehicleDoor?.value,
          dataPasses,
        },
        "entry"
      );
      setLoading(false);
      const status = res?.data?.status;
      if (status?.code !== 200) {
        openAlert(status?.message, "error");
      } else {
        reset();
        setpresentedData([]);
        setAuthorizedData([]);
        setpassesDataAuthorized([]);
        setSpecificSearch(null);
        setdataSearchVehiclePlate([]); // Importante limpiar la data original
        setHeaderInfo({ // Limpiar contadores
          pendingPass: null,
          pendingPassComex: null,
        });
        // actualizar
        openAlert(status?.message, "success");

        // getsearchVehiclePlateEntry();
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const registerServPublic = async () => {
    if (!selectTypeTransport) {
      openAlert("Seleccione un tipo de transporte", "error");
    } else if (!values.plateVehicleNewRegister) {
      openAlert("La placa es obligatoria", "error");
    } else if (!values.name) {
      openAlert("El nombre es obligatorio", "error");
    } else if (!values.identification) {
      openAlert("La identicación es obligatoria", "error");
    } else if (!values.description) {
      openAlert("La descripción es obligatorio", "error");
    } else if (!vehicleDoor) {
      openAlert("Debe seleccionar la puerta vehícular", "error");
    } else {
      setLoading(true);
      try {
        setLoading(false);
        const data = [
          {
            id: "",
            driver: values?.name,
            description: values?.description, // new
            container_1: values?.container_1,
            container_2: values?.container_2,
            identification: values?.identification,
            description_security: values?.description,
            typeTransport_id: selectTypeTransport?.value,
            vehicle_plate: values?.plateVehicleNewRegister,
            qualifiedUser_id: selectUserQualified?.value, // new
            capacity_container_1: values?.capacity_container_1,
            capacity_container_2: values?.capacity_container_2,
          },
        ];
        const res = await __postcreateSecurityEntryAndExit(
          token,
          {
            vehicularDoor_id: Number(vehicleDoor?.value),
            dataPasses: data,
          },
          "entry"
        );
        const status = res?.data?.status;
        if (status?.code !== 200) {
          openAlert(status?.message, "error");
        } else {
          openAlert(status?.message, "success");
          onCloseSearch(true);
          reset();
          setVehicleDoor(null);
          setSelectTypeTransport(null);
          setSelectUserQualified(null);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleRegisterFreePasse = async (params) => {
    if (!vehicleDoor) {
      openAlert("Debe seleccionar la puerta vehícular", "error");
    } else {
      setLoading(true);
      try {
        const res = await __postcreateSecurityEntryAndExit(
          token,
          {
            vehicularDoor_id: vehicleDoor?.value,
            dataPasses: params,
          },
          "entry"
        );
        setLoading(false);
        const status = res?.data?.status;
        if (status?.code !== 200) {
          openAlert(status?.message, "error");
        } else {
          reset();
          setpresentedData([]);
          setAuthorizedData([]);
          setpassesDataAuthorized([]);
          //  setdataSearchVehiclePlate([]);
          setSpecificSearch(null);
          setdataSearchVehiclePlate([]);
          setHeaderInfo({
            pendingPass: null,
            pendingPassComex: null,
          });

          openAlert(status?.message, "success");

          // !selectAuthorized && getsearchVehiclePlateEntry();
          // getsearchVehiclePlateEntry();
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleInput = (data) => {
    const index = dataPasses?.findIndex(
      (dataFind) => dataFind?.id === data?.id
    );

    if (index !== -1) {
      dataPasses[index] = data; // asignarle data al obj que tenga ese index
      setpassesDataAuthorized(dataPasses);
    }
  };

  const handleSelectTransport = (val) => {
    setSelectTypeTransport(val);
    const dataR = dataPasses.map((data) => ({
      ...data,
      typeTransport_id: val?.value || "",
    }));
    setpassesDataAuthorized(dataR);
  };

  function checkAvailability(arr, val) {
    return arr.some(function ({ id }) {
      return val === id;
    });
  }

  const transformArrayToObject = (arr) => {
    const result = {};
    arr.forEach((item) => {
      result[item?.id] = item;
    });
    return result;
  };

  const refetchForm = (flag, form_id, new_status) => {
    const transformed = transformArrayToObject(idPassAssociated);

    const shouldRefetch =
      (flag === "entry_pass" || flag === "dispatch_pass") &&
      new_status !== transformed?.[form_id]?.status &&
      checkAvailability(idPassAssociated, form_id);

    if (shouldRefetch) getsearchVehiclePlateEntry();
  };

  useStatusListener({
    id: idPassAssociated,
    callBack: refetchForm,
    dataCurrent: dataSearchVehiclePlate,
  });

  return (
    <>
      <HeaderSearch style={{ marginTop: 30, marginBottom: 15 }}>
        <div className="d-flex justify-content-between align-items-center m-lg-1">
          <Title>Registro de seguridad entrada</Title>
          <ButtonStyled
            type="submit"
            onClick={onOpenSearch}
          // disabled={!dataPasses.length ? true : false}
          >
            Nuevo registro
          </ButtonStyled>
        </div>

        <div className="row">
          <div className="col col-md-5">
            <form
              className="d-flex  mb-3"
              onSubmit={(event) => {
                event.preventDefault();
                getsearchVehiclePlateEntry();
              }}
            >
              <label
                style={{
                  width: "100%",
                }}
              >
                Placa vehículo
                <InputGroup>
                  <Input
                    w={"100%"}
                    h={"38px"}
                    color={"#000"}
                    outline={"none"}
                    fontSize={"1rem"}
                    backgroundColor={"#ffffff87"}
                    name="plateVehicle"
                    onChange={(e) =>
                      FuncionLetraNumberOnly(e, setValues, values)
                    }
                    value={values?.plateVehicle}
                    placeholder={"Ejemplo: ABC123"}
                  />
                  <InputRightElement style={{}} as="button">
                    <RiSearch2Line color="green.500" />
                  </InputRightElement>
                </InputGroup>
              </label>
            </form>
          </div>
    {/*       {headerInfo?.pendingPass !== null ||
            headerInfo?.pendingPassComex !== null ? (
            <div className="col col-md-2">
              <Flex
                w={"100%"}
                h={"100%"}
                direction={"column"}
                alignItems={"center"}
                justifyContent={"center"}
              >
                {headerInfo?.pendingPass !== null && (
                  <span
                    style={{
                      color: "black",
                      fontWeight: "700",
                    }}
                  >
                    Nº P.P: {headerInfo?.pendingPass}
                  </span>
                )}
                {headerInfo?.pendingPassComex !== null && (
                  <span
                    style={{
                      color: "black",
                      fontWeight: "700",
                    }}
                  >
                    Nº P.P.C: {headerInfo?.pendingPassComex}
                  </span>
                )}
              </Flex>
            </div>
          ) : (
            <div className="col col-md-2" />
          )} */}
          <div className="col col-md-2" />
          <div className="col  col-md-5">
            <form
              className="d-flex  mb-3"
              onSubmit={(event) => {
                event.preventDefault();
                getSearchCodeFormEntry();
              }}
            >
              <label
                style={{
                  width: "100%",
                }}
              >
                Búsqueda específica
                <InputGroup>
                  <Input
                    w={"100%"}
                    h={"38px"}
                    color={"#000"}
                    outline={"none"}
                    fontSize={"1rem"}
                    backgroundColor={"#ffffff87"}
                    name={"specificSearch"}
                    onChange={handleInputChange}
                    value={values?.specificSearch}
                    placeholder={"Búsqueda específica"}
                  />
                  <InputRightElement as="button">
                    <RiSearch2Line color="green.500" />
                  </InputRightElement>
                </InputGroup>
              </label>
            </form>
            <div className="spac" />
          </div>{" "}
        </div>

        <div className="d-flex  mb-3">
          <InputSelect
            value={vehicleDoor}
            set={setVehicleDoor}
            data={dataVehicheDoor}
            tag="Puerta Vehicular*"
            size={100}
          />
        </div>
      </HeaderSearch>
      <HeaderSearch style={{ marginTop: 30, marginBottom: 50 }}>
        {/*   <div className="d-flex justify-content-between align-items-center m-lg-1">
          <Title>Registro de seguridad entrada</Title>
          <ButtonStyled
            type="submit"
            className="ms-2"
            onClick={() => onOpenSearch(true)}
            // disabled={!dataPasses.length ? true : false}
          >
            Nuevo registro
          </ButtonStyled>
        </div> */}

        <ModalGeneric
          isOpen={isOpenSearch}
          onOpen={onOpenSearch}
          onClose={onCloseSearch}
          title="Registro de entrada"
        >
          <FormRegisterPublic
            reset={reset}
            values={values}
            onClose={onCloseSearch}
            vehicleDoor={vehicleDoor}
            onChange={handleInputChange}
            setVehicleDoor={setVehicleDoor}
            dataVehicheDoor={dataVehicheDoor}
            vehiclePlate={values.plateVehicle}
            handleRegister={registerServPublic}
            selectTypeTransport={selectTypeTransport}
            setSelectTypeTransport={setSelectTypeTransport}
            selectUserQualified={selectUserQualified}
            setSelectUserQualified={setSelectUserQualified}
            setValues={setValues}
            CreateDispacth={CreateDispacth}
            setCreateDispacth={setCreateDispacth}
          />
        </ModalGeneric>

        {loading && <SpinnerComponent />}

        {!dataSearchVehiclePlate?.length && specificSearch === null ? (
          <div className="containerInfo">
            <img src={window.assetURL + ImageNotFound} alt="vehicle" />
          </div>
        ) : (
          <>
            {specificSearch ? (
              <>
                <CardInfoSearchPlateVehicle
                  {...specificSearch}
                  destiny="entry"
                  specificSearch
                  uploaded={uploaded}
                  dataPasses={dataPasses}
                  handleInput={handleInput}
                  vehicleDoor={vehicleDoor}
                  typeTransport={typeTransport}
                  selectUserQualified={selectUserQualified}
                  setVehicleDoor={setVehicleDoor}
                  dataVehicheDoor={dataVehicheDoor}
                  handleRegisterFreePasse={handleRegisterFreePasse}
                  selectTypeTransport={selectTypeTransport}
                  setSelectTypeTransport={handleSelectTransport}
                />
                {specificSearch?.free_pass === 1 ||
                  (specificSearch?.status === authorized && (
                    <div className="btn-flotante">
                      <ButtonStyled
                        type="submit"
                        onClick={handleRegisterAllEntryAutorized}
                      >
                        Registrar
                      </ButtonStyled>
                    </div>
                  ))}
              </>
            ) : (
              <>
                <div className="h-100">
                  <div
                    className="d-flex mb-3 "
                    style={{
                      borderBottomWidth: 1,
                    }}
                  >
                    <div className="comer" style={{ width: "100%" }}>
                      <Title
                        size={16}
                        onClick={() => setSelectAuthorized(true)}
                        style={
                          selectAuthorized ? styleSelected : styleUnSelected
                        }
                      >
                        {/* Autorizados */}
                        <div style={{ display: "flex", justifyContent: "space-between"  }}>
                          <div style={{padding: "5px", marginRight: "10px"}}>SEGURIDAD</div>
                          <div style={{ padding: "5px"}}>Nº P.P: {authorizedData.length || 0}</div> {/* en caso de que la linea de abajo falle */}
                          {/* <div style={{ padding: "5px"}}>Nº P.P: {headerInfo?.pendingPass || 0}</div> */}
                        </div>

                      </Title>
                    </div>
                    <div className="comer" style={{ width: "100%" }}>
                      <Title
                        size={16}
                        onClick={() => setSelectAuthorized(false)}
                        style={
                          !selectAuthorized ? styleSelected : styleUnSelected
                        }
                      >
                          <div style={{ display: "flex", justifyContent: "space-between" }}>
                          <div style={{padding: "5px", marginRight: "10px"}}>COMERCIO EXTERIOR</div>
                          <div style={{padding: "5px"}}> Nº P.P.C: {presentedData.length || 0}</div> {/* en caso de que la linea de abajo falle */}
                          {/* <div style={{padding: "5px"}}> Nº P.P.C: {headerInfo?.pendingPassComex || 0}</div> */}
                        </div>
                      </Title>
                    </div>
                  </div>

                  {selectAuthorized ? (
                    <div className="row">
                      {authorizedData.map((item, i) => (
                        <CardInfoSearchPlateVehicle
                          key={i}
                          {...item}
                          id={i}
                          destiny="entry"
                          dataPasses={dataPasses}
                          handleInput={handleInput}
                          vehicleDoor={vehicleDoor}
                          typeTransport={typeTransport}
                          setVehicleDoor={setVehicleDoor}
                          dataVehicheDoor={dataVehicheDoor}
                          setSelectTypeTransport={handleSelectTransport}
                          selectTypeTransport={selectTypeTransport}
                          selectUserQualified={selectUserQualified}
                          handleRegisterFreePasse={handleRegisterFreePasse}
                          isDisable_TypeTransport={IsActive}
                          hide_inform={IsActive}
                          isDisable_nItems={IsActive}
                          createStatusdispatch={createStatusdispatch}
                          headerInfo={headerInfo}
                          showAmountItems={false}
                        />
                      ))}
                    </div>
                  ) : (
                    <div className="row">
                      {presentedData.map((item, i) => (
                        <CardInfoSearchPlateVehicle
                          key={i}
                          {...item}
                          id={i}
                          destiny="entry"
                          dataPasses={dataPasses}
                          handleInput={handleInput}
                          vehicleDoor={vehicleDoor}
                          typeTransport={typeTransport}
                          uploaded={uploaded}
                          setVehicleDoor={setVehicleDoor}
                          dataVehicheDoor={dataVehicheDoor}
                          selectUserQualified={selectUserQualified}
                          setDataFreePasses={setDataFreePasses}
                          setSelectTypeTransport={handleSelectTransport}
                          selectTypeTransport={selectTypeTransport}
                          handleRegisterFreePasse={handleRegisterFreePasse}
                          setpassesDataAuthorized={setpassesDataAuthorized}
                          isDisable_TypeTransport={IsActive}
                          hide_inform={IsActive}
                          isDisable_nItems={IsActive}
                          createStatusdispatch={createStatusdispatch}
                          headerInfo={headerInfo}
                          disabledTextarea={true}
                          showAmountItems={true}
                        />
                      ))}
                    </div>
                  )}

                  {selectAuthorized ? (
                    <div className="btn-flotante">
                      <ButtonStyled
                        type="submit"
                        // onClick={() => handleRegisterAllEntryAutorized()}
                        onClick={handleSubmitRegisterAll}
                        disabled={
                          !dataPasses.length
                            ? true
                            : false ||
                            (headerInfo?.pendingPassComex !== null &&
                              headerInfo?.pendingPassComex !== 0)
                        }
                      >
                        Registrar todos
                      </ButtonStyled>
                    </div>
                  ) : (
                    // <div className="btn-flotante">
                    //   <ButtonStyled
                    //     type="submit"
                    //     onClick={() => handleRegisterAllFreePasse()}
                    //     disabled={!dataFreePasses.length ? true : false}
                    //   >
                    //     Registar pases libres
                    //   </ButtonStyled>
                    // </div>
                    <></>
                  )}
                </div>
              </>
            )}
          </>
        )}
      </HeaderSearch>{" "}
    </>
  );
};

export default EntriesVehicle;
